export const fallbackSidebarLinks = [
    {
        href: '/app/dashboard',
        icon: {
            selected: 'navDashboardFill',
            unselected: 'navDashboard',
        },
        text: 'Dashboard',
    },
    {
        href: '/app/zaps',
        icon: {
            selected: 'miscBoltAltFill',
            unselected: 'miscBoltAlt',
        },
        text: 'Zaps',
    },
    {
        href: '/app/transfers',
        icon: {
            selected: 'arrowConnect',
            unselected: 'arrowConnect',
        },
        text: 'Transfers',
    },
    {
        href: `https://tables.zapier.com/`,
        icon: {
            selected: 'navTableFill',
            unselected: 'navTable',
        },
        text: 'Tables (beta)',
    },
    {
        href: `https://interfaces.zapier.com/`,
        icon: {
            selected: 'navInterfacesFill',
            unselected: 'navInterfaces',
        },
        text: 'Interfaces (beta)',
    },
    {
        href: '/app/connections',
        icon: {
            selected: 'navAppsFill',
            unselected: 'navApps',
        },
        text: 'My apps',
    },
    {
        href: '/app/history/usage',
        icon: { selected: 'miscClockFill', unselected: 'miscClock' },
        text: 'Zap History',
    },
    {
        href: '/help',
        icon: { selected: 'navHelpFill', unselected: 'navHelp' },
        text: 'Get Help',
    },
];
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
